import { Component, Input, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-creditor-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  hideFooterMenu:boolean=false;
  isPostLogin:boolean=false;
  @Input('hide-footer-menu') set _hideFooterMenu(val) {
    this.hideFooterMenu = val;
  }
  
  constructor(private router: Router) {
    if(sessionStorage.getItem('userId')){
      this.isPostLogin=true;
     }
     else{
       this.isPostLogin=false;
     }
  }
  public year : any;
  ngOnInit(): void {
   this.year = new Date().getFullYear();
   
   this.router.events.subscribe((val) => {
    if (val instanceof NavigationStart) {
      if(sessionStorage.getItem('userId')){
       this.isPostLogin=true;
      }
      else{
        this.isPostLogin=false;
      }
    }}); 
  }

  redirectToContactUs() {

    const url = this.router.serializeUrl(
      this.router.createUrlTree(["contact-us"])
    );
    window.open(url, '_blank');
  }

  redirectToTermsAndConditions() {

    const url = this.router.serializeUrl(
      this.router.createUrlTree(["terms-and-conditions", {isFromFooter: true}])
    );
    window.open(url, '_blank');
  }
  
  redirectToAboutUs(){
    this.router.navigate(['about-us']);
  }

  redirectToFAQ(){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['faq'])
    );
    window.open(url, '_blank');
  }
}
